import React, { useMemo, useState, useCallback } from "react";
import { useParams, useSearchParams } from "react-router-dom";

import MobileFormContentManager from "../../components/common/mobile/MobileFormContentManager";
import UserForm from "../../components/common/form/UserForm";
import MobileReportEditor from "../../components/safety/editor/MobileReportEditor";
import MobileChecklistEditor from "../../components/safety/editor/MobileChecklistEditor";
import MobileRiskcheckEditor from "../../components/safety/editor/MobileRiskcheckEditor";
import MobileIncidentEditor from "../../components/safety/editor/MobileIncidentEditor";
import MobileSCAREditor from "../../components/safety/editor/MobileSCAREditor";


const DOC_LABELS = {
  SPP: "안전 계획",
  ISC: "점검 일정",
  RAS: "위험성 평가",
  INC: "사고 이력",
  CAR: "안전 시정 조치 요구서",
};

// 모바일 전용 에디터 매핑
const MOBILE_STD_FORMS = {
  SPP: MobileReportEditor, // 모바일 전용
  ISC: MobileChecklistEditor, // 모바일 전용
  RAS: MobileRiskcheckEditor, // 모바일 전용
  INC: MobileIncidentEditor, // 모바일 전용
  CAR: MobileSCAREditor, // 모바일 전용
};

const SCOPE_BY_FORM = (ft) => {
  if (ft === "SPP") return "report";
  if (ft === "RAS") return "riskcheck";
  if (ft === "INC") return "incident";
  if (ft === "ISC") return "check";
  if (ft === "CAR") return "scar";
  return "report";
};

export default function SafetyForm() {
  const projectId = localStorage.getItem("projectId");
  const { mode } = useParams();
  const [sp] = useSearchParams();

  const currentUser = useMemo(() => {
    try {
      const raw = localStorage.getItem("user");
      return raw ? JSON.parse(raw) : null;
    } catch {
      return null;
    }
  }, []);

  const intMode = Math.max(1, Math.min(2, Number(mode) || 1));
  const formType = (sp.get("form_type") || "SPP").toUpperCase();
  const stage = (sp.get("stage") || "").toUpperCase();

  const docLabel = DOC_LABELS[formType] || formType;
  const scope = SCOPE_BY_FORM(formType);

  const [stdBody, setStdBody] = useState(null);

  // 모바일 전용 에디터 사용
  const StdForm = MOBILE_STD_FORMS[formType];

  console.log("SafetyForm — stdBody:", stdBody);

  const getBody = useCallback(
    () => ({
      layout: null,
      values: {
        project: projectId,
        module: "safety",
        doc_type: scope, // ← SPP / ISC / RAS / INC / CAR
        title: stdBody?.title || "", // ← 없으면 나중에 auto 생성 가능
        status: "none",
        meta: stdBody?.meta || {}, // ⭐ 여기! PlanEditor의 meta를 감싸서 meta로 보냄
      },
      attachmentRef: stdBody?.attachmentRef, // ⭐ 각 에디터에서 전달하는 attachmentRef
    }),
    [projectId, stdBody, scope]
  );

  return (
    <div
      className="mobile-page-root mb-16"
      style={{ width: '100%', maxWidth: '100vw', minWidth: 0, display: 'flex', justifyContent: 'center', overflowX: 'hidden', boxSizing: 'border-box' }}
    >
      <div
        className="mobile-page-root-inner space-y-3"
        style={{ width: '100%', maxWidth: '480px', margin: '0 auto', padding: '0 1rem 1rem', boxSizing: 'border-box', overflowX: 'hidden' }}
      >
        {intMode === 2 && (
          <div className="bg-white rounded-lg border p-3 min-w-0 overflow-hidden">
            <UserForm
              mode={intMode}
              module="safety"
              formType={formType}
              scope={scope}
              project={projectId}
              defaultTitle={`${docLabel} (사용자 템플릿)`}
            />
          </div>
        )}

        {intMode === 1 && StdForm && (
          <MobileFormContentManager
            params={{
              module: "safety",
              project: projectId,
              doc_type: formType,
              stage,
            }}
            docName={docLabel}
            docDescribe={`${docLabel} 작성 및 저장`}
            getBody={getBody}
            onChangeId={(dns) => console.log("생성된 DNS:", dns)}
            onSaved={() => alert("문서 저장 완료")}
            summaryConfig={{ showPhotoSummary: true }}
            requestPeople={Array.isArray(stdBody?.meta?.referenceUserDetails) ? stdBody?.meta?.referenceUserDetails : []}
          >
            <div className="min-w-0 overflow-x-hidden space-y-3">
              <StdForm
                projectId={projectId}
                formType={formType}
                docLabel={docLabel}
                initial={{ subtype: stage }}
                readOnly={false}
                onChange={setStdBody}
                currentUser={currentUser}
              />
            </div>
          </MobileFormContentManager>
        )}
      </div>
    </div>
  );
}
